import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline'
import { useQuery } from '@tanstack/react-query'
import { toast } from 'react-toastify'

import { getInfestationReports } from '@/services/get-infestation-reports'

import { useCompanies } from '../use-companies'

export type UseGetInfestationReportsData = NonNullable<
  ReturnType<typeof useGetInfestationReports>['data']
>
export type InfestationReport = UseGetInfestationReportsData[number]

export const GET_INFESTATION_REPORTS_QUERY = 'GET_INFESTATION_REPORTS_QUERY'

export const useGetInfestationReports = () => {
  const { selectedCompany } = useCompanies()
  const query = useQuery({
    queryKey: [GET_INFESTATION_REPORTS_QUERY, selectedCompany.id],
    queryFn: ({ signal }) =>
      getInfestationReports(selectedCompany.id, { signal }),

    select: (reports) =>
      reports.map((report) => {
        const createdAt = new Date(report.created_at)
        return {
          ...report,
          created_at: createdAt.toLocaleDateString('pt-BR'),
          time_from_created_at: new Intl.DateTimeFormat('pt-BR', {
            hour: '2-digit',
            minute: '2-digit',
            hour12: false,
          }).format(createdAt),
          initial_conclusion_date: new Date(
            report.initial_conclusion_date,
          ).toLocaleDateString('pt-BR'),
          final_conclusion_date: new Date(
            report.final_conclusion_date,
          ).toLocaleDateString('pt-BR'),
        }
      }),
    onError: () =>
      toast.error(
        'Não foi possível carregar as informações. Tente novamente.',
        {
          icon: <ErrorOutlineIcon />,
        },
      ),
  })

  return query
}
